import config from '@/config'

const SITE_URL = config.siteUrl.replace(/\/+$/, '')

export function siteUrl(path = '/'): string {
    if (/^https?:\/\//i.test(path)) return path
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    return `${SITE_URL}${normalizedPath}`
}

export { SITE_URL }
